import React, { useEffect, useState } from "react";
import { Rate, Typography } from "antd";
import { Flex } from "antd-mobile";
import { useAllergens, usePreservatives } from "../AllergensContext";
import { useDispatch, useSelector } from "react-redux";
import { setAllergenPreservativesFilter, setSpiceFilter } from "../../../../../../redux/actions";
import { useSpiceLevels } from "../../../../../DigitalMenu/SpiceLevelCtx";
import Chilli from '../../../../../../static/Chili';


const { Title } = Typography;

function DishesFilter(props) {
  const allergens = useAllergens();
  const preservatives = usePreservatives();
  const dispatch = useDispatch();
  const spiceLevels = useSpiceLevels();
  const selectedSpiceLevel = useSelector(
    (state) => state.digitalMenuConfig.spiceFilter
  );

  const selectedFilters = useSelector(
    (state) => state.digitalMenuConfig.allergensPreservativesFilters
  );
  const [selectedFitlersIds, setSelectedFitlersIds] = useState([]);
  const selectAllergen = (allergen) => {
    let isSelected = false;
    let isSelectedIndex = null;
    selectedFilters.forEach((_allergen, index) => {
      if (_allergen.id === allergen.id) {
        isSelected = true;
        isSelectedIndex = index;
      }
    });
    if (!isSelected) {
      dispatch(setAllergenPreservativesFilter([...selectedFilters, allergen]));
    } else {
      const _selectedFilters = Array.from(selectedFilters);
      _selectedFilters.splice(isSelectedIndex, 1);
      dispatch(setAllergenPreservativesFilter([..._selectedFilters]));
    }
  };

  useEffect(() => {
    setSelectedFitlersIds(selectedFilters.map((filter) => filter.id));
  }, [selectedFilters]);

  const selectSpiceLevel = (spiceLevel) => {
    dispatch(setSpiceFilter(spiceLevel));
  }

  return (
    <div>
      <Flex>
        <Flex.Item>
          <Title level={4} className="p-l-4">Ich bin allergisch gegen</Title>
        </Flex.Item>
      </Flex>
      <Flex>
        <Flex.Item>
          <div class="allergens-container">
            {allergens.map((allergen) => (
              <div
                className="allergen"
                key={`allergen-${allergen.id}`}
                onClick={() => selectAllergen(allergen)}
              >
                <div
                  className={`alergen-content ${
                    selectedFitlersIds.indexOf(allergen.id) >= 0 ? "selected" : ""
                  }`}
                >
                  <div>{allergen.name}</div>
                </div>
              </div>
            ))}
          </div>
        </Flex.Item>
      </Flex>
      <Flex>
        <Flex.Item>
          <Title level={4} className="p-l-4">Ich mag es</Title>
        </Flex.Item>
      </Flex>
      <Flex>
        <Flex.Item>
        <Rate
          allowClear
          defaultValue={selectedSpiceLevel}
          count={spiceLevels.length}
          tooltips={spiceLevels.map(level => level.name)}
          className="chilli-mobile"
          character={<Chilli />}
          onChange={selectSpiceLevel}
        />
        </Flex.Item>
      </Flex>
      <Flex>
        <Flex.Item>
          <Title level={4} className="p-l-4">Bitte ohne</Title>
        </Flex.Item>
      </Flex>
      <Flex>
        <Flex.Item>
          <div class="allergens-container">
            {preservatives.map((preservative) => (
              <div
                className="allergen"
                key={`preservative-${preservative.id}`}
                onClick={() => selectAllergen(preservative)}
              >
                <div
                  className={`alergen-content ${
                    selectedFitlersIds.indexOf(preservative.id) >= 0 ? "selected" : ""
                  }`}
                >
                  <div>{preservative.name}</div>
                </div>
              </div>
            ))}
          </div>
        </Flex.Item>
      </Flex>
    </div>
  );
}

export default DishesFilter;
